import { render, staticRenderFns } from "./Content.vue?vue&type=template&id=821f2d52&scoped=true&lang=pug&"
import script from "./Content.vue?vue&type=script&lang=js&"
export * from "./Content.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "821f2d52",
  null
  
)

export default component.exports